import React, { createContext, useContext, PropsWithChildren } from 'react';

import { Libraries, useJsApiLoader } from '@react-google-maps/api';

import GOOGLE_MAP_API_KEY from 'core/constants/GoogleMapApiKey';

const googleMapsScriptLibraries: Libraries = ['places'];

interface GoogleMapsContextProps {
  isLoaded: boolean;
  loadError: Error | undefined;
}

const GoogleMapsContext = createContext<GoogleMapsContextProps | undefined>(undefined);

const GoogleMapsProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: GOOGLE_MAP_API_KEY,
    libraries: googleMapsScriptLibraries
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export function useGoogleMaps(): GoogleMapsContextProps {
  const context = useContext(GoogleMapsContext);
  if (!context) {
    throw new Error('useGoogleMaps must be used within a GoogleMapsProvider');
  }
  return context;
}

export default GoogleMapsProvider;
